export default "__VITE_ASSET__f3ku6cVH__"